import { Sparkles } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

/**
 * Espaço reservado para a leitura do assistente sobre a rodada.
 *
 * O fluxo que gera o texto ainda não existe; o espaço nasce antes de propósito. Duas razões: a
 * altura da tela não pode saltar quando a leitura chegar, e o lugar da narrativa é acima dos
 * gráficos — quem abre a tela quer saber o que aconteceu antes de conferir os números.
 *
 * O texto abaixo é um exemplo declarado como exemplo. Um placeholder que não se anuncia como
 * placeholder é pior que espaço vazio: alguém decide com base nele.
 */
export function AssistantReadingSlot() {
  return (
    <Card className="mb-4 border-brand-100">
      <CardContent className="pt-5">
        <p className="inline-flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.08em] text-brand-600">
          <Sparkles className="h-3 w-3" aria-hidden />
          Leitura do assistente
        </p>
        <p className="mt-2 max-w-[78ch] text-[13px] leading-relaxed text-text-secondary">
          <span className="font-medium text-text-primary">
            Exemplo — ainda não é uma leitura real.
          </span>{" "}
          Quando o fluxo existir, aqui vai a explicação do que o motor encontrou: qual configuração
          venceu, por que ela venceu no objetivo escolhido, e o que observar antes de aplicar —
          escrita a partir dos resultados desta rodada.
        </p>
        <p className="mt-3 border-t border-border-subtle pt-2.5 text-[10px] text-text-tertiary">
          A leitura sempre citará os números desta rodada · confira os painéis abaixo antes de
          aplicar qualquer ajuste
        </p>
      </CardContent>
    </Card>
  );
}
